import axios from 'axios';
import { usuarioApiURL } from '../Utils/helper-tipo-usuario';
import { IResetUser, ProfileChangePassword } from '../Interfaces/IProfile';

const baseURL = usuarioApiURL();

const config = {
  headers: {
    'Content-Type': 'application/json',
  },
};

export const setChangePassword = (data: ProfileChangePassword) => {
  return axios.post(baseURL + 'retoAsesoria/ActualizarClave', data, config);
};

export const resetUser = (data: IResetUser) => {
  return axios.post(baseURL + 'fit4/reiniciarFit4', data, config);
};

